var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDialBackspace = function SvgDialBackspace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.674 8H14.2092C12.5547 8 11.0462 8.624 9.82969 9.728L0.729927 18.32C0.291971 18.752 0 19.376 0 20C0 20.624 0.243309 21.248 0.729927 21.728L9.82969 30.272C10.9976 31.376 12.5547 32 14.2092 32H33.674C37.1776 32 40 29.216 40 25.76V14.24C40 10.784 37.1776 8 33.674 8Z",
    fill: "#F5F5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.697 19.9204L28.4965 17.0088C28.8679 16.6375 28.8423 16.0471 28.4639 15.7003L28.4558 15.6928L28.448 15.685C28.0766 15.3136 27.4862 15.3394 27.1394 15.7177L27.1312 15.7267L24.3451 18.6239L21.4406 15.8311C21.0692 15.4597 20.4789 15.4854 20.1321 15.8637L20.1246 15.8719L20.1168 15.8797C19.7454 16.2511 19.7711 16.8414 20.1495 17.1882L20.1584 17.1965L23.0557 19.9825L20.2628 22.887C19.8915 23.2584 19.9171 23.8487 20.2955 24.1955L20.3036 24.203L20.3114 24.2108C20.4837 24.3831 20.6804 24.451 20.9734 24.451C21.2353 24.451 21.4909 24.3535 21.6808 24.1653L24.4629 21.2719L27.3675 24.0648C27.5397 24.237 27.7364 24.3051 28.0293 24.3051C28.2927 24.3051 28.5497 24.2065 28.7399 24.0162C29.1113 23.6448 29.0856 23.0544 28.7072 22.7076L28.7054 22.7059L25.697 19.9204Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDialBackspace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dialBackspace.771eae8d.svg";
export { ForwardRef as ReactComponent };